<template>
	<v-row class="bg-white">
		<v-col cols="5" xl="4" class="pa-0">
			<v-tabs
				:show-arrows="false"
				v-model="m_tab"
				active-class="classColor"
			>
				<v-tabs-slider
					style="margin-left: 10%; width: 80%"
					:color="customColors['mbf-color-4']"
				></v-tabs-slider>
				<v-tab v-for="tab in tabs" class="uppercase" :key="tab.key">
					<span class="font-bold">{{ tab.title }}</span>
				</v-tab>
			</v-tabs>
		</v-col>
		<!-- v-if = "button.isShow" check button -->
		<v-col cols="7" xl="8" class="pa-0">
			<div v-for="button in buttons" :key="button.title">
				<v-btn
					v-if="button.isShow"
					:color="button.color"
					:dark="button.dark"
					depressed
					:outlined="button.outlined"
					@click="$emit('buttonClick', button.event)"
					class="m-1 rounded-lg float-right px-2"
					:class="!button.outlined ? 'white--text' : ''"
				>
					<v-icon small class="mr-1" v-if="!!button.icon">{{
						button.icon
					}}</v-icon>
					<span class="text-xs font-medium normal-case">
						{{ button.title }}
					</span>
				</v-btn>
			</div>
		</v-col>
	</v-row>
</template>

<script>
import constant from "@/common/constant";
export default {
	name: "TabVueV2",
	props: {
		tab: {},
		tabs: { default: { key: "", title: "" } },
		buttons: {
			default: {
				icon: "",
				title: "",
				color: "",
				outlined: true,
				transparent: true,
				dark: false,
				event: function () {
					console.log("event");
				},
				isShow: false,
			},
		},
	},
	watch: {
		tab(value) {
			this.m_tab = value;
		},
		m_tab(value) {
			this.$emit(constant.keys.tab, value);
		},
	},
	data() {
		return { m_tab: {} };
	},
};
</script>

<style lang="scss" scoped>
.classColor {
	color: #002060;
}
</style>
